import React, {useEffect, useState} from 'react';

import './Select.scss';
import {SelectLog} from "../../services/interactions/elements/select";

function Select({ value, onChange, onClick, placeholder, label, options, required, error, disabled, hasScroll, toTop }) {
    const inputRef = React.createRef();
    const [focused, setFocused] = useState(false);
    const [mouseOnOptions, setMouseOnOptions] = useState(false);
    const [_toTop, setToTop] = useState(toTop);

    const optionsElement = React.createRef();

    useEffect(() => {
        if (focused) {
            updatePosition();
        }
    }, [focused])

    const focusIn = () => {
        if (onClick) {
            onClick(true);
        }
        setFocused(true);
    }
    const overlayClick = () => {
        setTimeout(() => {
            setFocused(false);
            setMouseOnOptions(false);
        }, 120)
    }
    const focusOut = () => {
        if(!mouseOnOptions){
            if (onClick) {
                onClick(false);
            }
            setFocused(false);
        }
    }

    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    const updatePosition = () => {
        const windowDimensions = getWindowDimensions();
        const inputClientRect = inputRef.current.getBoundingClientRect();
        const clientRect = optionsElement.current.getBoundingClientRect();
        const top = inputClientRect.top + clientRect.height;
        const t = (top) > windowDimensions.height;
        setToTop(t);
    }

    const toggleFocus = (e) => {
        if(!focused){
            inputRef.current.focus();
        }else{
            inputRef.current.blur();
        }
    }
    const overOptions = () => {
        setMouseOnOptions(true);
    }
    const outsideOptions = () => {
        setMouseOnOptions(false);
    }

    const selectOption = (option) => {
        return () => {
            if(!!option.disabled){
                return;
            }
            console.log('[SELECT] value: ', option.value);
            onChange(option.value);
            setFocused(false);
        }
    }
    const optionLabel = !!value || value === 0 ? options.find(o => o.value === value) : '';
    return (
        <div className={`__Select ${label ? 'withLabel' : ''} ${focused ? 'focused' : ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
            <label>{label}{required ? <span className="__req">*</span> : ''}</label>
            <select ref={inputRef} onFocus={focusIn} onBlur={focusOut} disabled={!!disabled}></select>
            <div className="__value" onClick={toggleFocus}>
                {
                    !optionLabel ?
                        <p className="placeholder">{placeholder}</p>
                        : <p className={`${optionLabel.subLabel ? '_subLabel' : ''}`}>
                            {optionLabel.label}
                            { optionLabel.subLabel? <span>{optionLabel.subLabel}</span> : '' }
                        </p>
                }
                <i className="material-icons">
                    keyboard_arrow_down
                </i>
            </div>
            <div ref={optionsElement} className={`__options ${hasScroll ? 'scrollBar' : ''} ${_toTop ? 'toTop' : ''}`} onMouseOver={overOptions} onMouseOut={outsideOptions}>
                {options.map(o => (
                    <div className={`__option ${o.disabled ? '_disabled' : ''} ${ !!value && value === o.value ? '_selected' : ''}`} key={o.value} onClick={selectOption(o)}>
                        <p>{o.label}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SelectLog(Select);
